import React, { useEffect, useState } from "react";
import Image from "next/image";
import { TfiUser } from "react-icons/tfi";
import { PiChatsCircle } from "react-icons/pi";
import { IoCallOutline } from "react-icons/io5";
export const GeneralSurgeryMdDetail = ({id,surgeonData, introImg, title, mdname, mdcontent }) => {
 
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          const headerOffset = 90;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }, 200);
      }
    }
  }, []);
  return (
    <section id={id || "generalsurgerydetail-page"}>
      <div className="generalsurgerydetail-page">
        <div className="container">
          <section className="doctor-section">
            <div className="container2">
              <div className="doctor-image">
                <Image
                  alt={"dt"}
                  className="b-r-5"
                  src={introImg}
                  width={500} // set your preferred width
                  height={500} // set your preferred height
                  style={{ objectFit: "cover", objectPosition: "top" }}
                />
              </div>
              <div className="doctor-info">
                <h4 className="designation font-nunito-sans p-16 color-blue2 f-w-500">
                  {title}
                </h4>
                <h2 className="doctor-name f-w-500 color-white">{mdname}</h2>
                <p className="description f-w-400 p-16 font-nunito-sans color-white">
                  {mdcontent}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="doctor-content">
        <div className="container doctor-profile">
          <div className="profile-left">
            <ul className="info-list">
              <li>
                <TfiUser className="color-black" />
                {surgeonData.gender}
              </li>
              <li>
                <PiChatsCircle className="color-black" /> {surgeonData.language}
              </li>
              <li>
                <IoCallOutline className="color-black" /> {surgeonData.phone}
              </li>
            </ul>

            <div className="section">
              <h3>SPECIALTY</h3>
              <p>{surgeonData.specialty}</p>
            </div>

            <div className="section">
              <h3>DEGREES</h3>
              {/* <p>
                Doctor of Medicine
                <br /> Bachelor of Arts, Biology
              </p> */}
              <p>
                {surgeonData.degrees.map((line, i) => (
                  <React.Fragment key={"deg-" + i}>
                    {line.trim()}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>

            <div className="section">
              <h3>CLINIC LOCATIONS</h3>
              <ul className="clinic-list">
                {surgeonData.clinics.map((item, i) => (
                  <li key={"clinic-" + i}>
                    <strong>{item.name}</strong>
                    <br />
                    {item.address}
                    <br />
                    {item.phone}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="profile-right">
            <section className="about">
              <h2>{surgeonData.bio_name || `About ${surgeonData.name}`}</h2>
              <div dangerouslySetInnerHTML={{ __html: surgeonData.bio || surgeonData.aboutBio }} />
            </section>

            <section className="education">
              <h2>EDUCATION</h2>
              <ul>
                {surgeonData.education.map((item, i) => (
                  <li key={"Ed" + i} style={{ whiteSpace: "pre-line" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            <section className="expertise">
              <h2>AREAS OF EXPERTISE</h2>
              {surgeonData.areasOfExpertise ? (
                <div
                  className="expertise-grid"
                  dangerouslySetInnerHTML={{
                    __html: surgeonData.areasOfExpertise,
                  }}
                />
              ) : surgeonData.expertise ? (
                <div className="expertise-grid">
                  <ul>
                    {surgeonData.expertise.slice(0, Math.ceil(surgeonData.expertise.length / 2)).map((exp, i) => (
                      <li key={`exp1-${i}`}>{exp}</li>
                    ))}
                  </ul>
                  <ul>
                    {surgeonData.expertise.slice(Math.ceil(surgeonData.expertise.length / 2)).map((exp, i) => (
                      <li key={`exp2-${i}`}>{exp}</li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};
